import { SavedSearchNS } from "../models/saved-search.models";
import { DataTypeWithOperatorNS, DateTimeOperatorValue } from "../models/saved-search.static";
import { MultiSelectFieldsNS } from '../models/saved-search-multiselect-fields.static';


export function prepareSavedSearchRuleValues(rule: SavedSearchNS.IRuleList, users: any[]): { value, value2 } {
    let value;
    let value2;
    let valueRefId: string[] = [];

    let booleanValueDD: SavedSearchNS.BooleanValue[] = [
        { id: 1, name: "true" },
        { id: 2, name: "false" },
    ];

    if (rule) {
        let selectedDataTypeAndOperator = DataTypeWithOperatorNS.SavedSearchDataTypeWithOperator.find(x => x.DataType == rule.filter.fieldDataType && x.Operator == rule.operator.name);
        // String
        if (rule.filter.fieldDataType == 'String') {
            if (selectedDataTypeAndOperator?.Operator == 'HasValue') {
                value = 'Any';
            }
            else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'No_Value') {
                value = null;
            }
            else {
                if (rule.filter.valueDataType == 'User') {
                    let arrStr = [];
                    rule?.value?.forEach((val: any, i) => {
                        let id: number = 0;
                        if (rule?.valueRefId[i]) {
                            id = parseInt(rule.valueRefId[i] ?? "") ?? 0;
                        }
                        let userObj = users.find(x => x.id == id);
                        if (userObj) {
                            arrStr.push(userObj);
                        }
                    });
                    value = arrStr;
                }
                else if (rule.filter.valueDataType == 'Year') {
                    const dateFrom = new Date(rule.value[0]);
                    if (dateFrom) {
                        value = dateFrom;
                    }
                }
                else if (rule.filter.valueDataType == 'AutoCompleteDropdown' && MultiSelectFieldsNS.AutoCompleteDropdownFieldsArray.includes(rule.filter.field?.toLowerCase())) {
                    // let val = null;
                    // if (rule.value[0]) {
                    //     val = {
                    //         id: 0,
                    //         name: rule.value[0],
                    //         businessName: rule.value[0],
                    //     };
                    //     // val = rule.value[0];
                    // }
                    // value = rule.value;

                    let arrStr = [];
                    rule?.value?.forEach((val: any, i) => {
                        let id: any;
                        if (rule?.valueRefId[i]) {
                            id = rule.valueRefId[i] ?? val;
                        }
                        arrStr.push({ id: id, name: val });
                    });
                    value = arrStr;
                } else if (rule.filter.valueDataType == 'AutoCompleteDropdown' && MultiSelectFieldsNS.AutoCompleteProductFieldsArray.includes(rule.filter.field?.toLowerCase())) {
                    let val = null;
                    if (rule.value[0]) {
                        val = {
                            id: 0,
                            item2: rule.value[0],
                        };
                        // val = rule.value[0];
                    }
                    value = val;
                }
                else {
                    value = rule.value[0];
                }
            }
        }
        //Number
        else if (rule.filter.fieldDataType == 'Number' || rule.filter.fieldDataType == 'Decimal' || rule.filter.fieldDataType == 'Money') {
            if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'No_Value') {
                value = [];
            }
            else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'Single_Value') {
                value = rule.value[0];
            }
            else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'Between_Value') {
                const numberFrom = rule.value[0].split('AND')[0];
                const numberTo = rule.value[0].split('AND')[1];
                value = parseInt(numberFrom ?? "") ?? null;
                value2 = parseInt(numberTo ?? "") ?? null;
            }
            else {
                value = rule.value[0];
            }
        }
        // Distance
        else if (rule.filter.fieldDataType == 'Distance') {
            let addressLatLng: SavedSearchNS.AddressLatLong = JSON.parse(rule.value[0]);
            value = addressLatLng ?? {};
        }
        //Boolean
        else if (rule.filter.fieldDataType == 'Boolean') {
            value = booleanValueDD.find(x => x.name.toLowerCase() == rule.value[0]) ?? booleanValueDD[0];
        }
        //DateTime
        else if (rule.filter.fieldDataType == 'DateTime') {
            if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'No_Value') {
                value = [];
            }
            else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'Single_Value') {
                const dateFrom = rule.value[0];
                // if (dateFrom) {
                //     let dateValue = DateTimeOperatorValue.find(x => x.code == dateFrom);
                //     // value = new Date(dateFrom);
                //     value = dateValue;
                // }
                if (selectedDataTypeAndOperator?.Operator == 'Is') {
                    if (dateFrom) {
                        const isDate = new Date(dateFrom);
                        if (!isNaN(isDate.getTime())) {
                            let dateValue = DateTimeOperatorValue.find(x => x.code == 'custom');
                            value2 = dateValue;
                            value = new Date(dateFrom);
                        }
                        else {
                            let dateValue = DateTimeOperatorValue.find(x => x.code == dateFrom);
                            value2 = dateValue;
                        }
                    }
                }
                else {
                    // const dateFrom = rule.value?.toLocaleDateString('sv');
                    value = new Date(dateFrom);
                }
            }
            else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'Between_Value') {
                const dateFrom = rule.value[0].split('AND')[0];
                const dateTo = rule.value[0].split('AND')[1];
                if (dateFrom && dateTo) {
                    value = [];
                    value[0] = new Date(dateFrom);
                    value[1] = new Date(dateTo);
                }
            }
            else {
                value = rule.value[0];
            }
        }
        //Time
        else if (rule.filter.fieldDataType == 'Time') {
            if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'No_Value') {
                value = [];
            }else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'Between_Value') {
                value = rule.value;
            } else {
                value = rule.value[0];
            }
        }
        //Enum
        else if (rule.filter.fieldDataType == 'Enum') {
            //Custom
            if (rule.filter.custom == true) {
                if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'No_Value') {
                    if (selectedDataTypeAndOperator?.Operator == 'HasValue') {
                        value = 'Any';
                    }
                    else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'No_Value') {
                        value = null;
                    }
                } else if (rule.filter.valueDataType == 'MultiSelect') {
                    let arrStr = [];
                    rule?.value?.forEach((val: any, i) => {
                        let id: any;
                        if (rule?.valueRefId[i]) {
                            id = rule.valueRefId[i] ?? val;
                        }
                        arrStr.push({ id: id, name: val });
                    });
                    value = arrStr;
                }
            }
            else {
                if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'No_Value') {
                    if (selectedDataTypeAndOperator?.Operator == 'HasValue') {
                        value = 'Any';
                    }
                    else if (selectedDataTypeAndOperator?.NoOfValuesToBePassed == 'No_Value') {
                        value = null;
                    }
                } else {
                    if (rule.filter.valueDataType == 'MultiSelect' || rule.filter.valueDataType == 'MultiSelectAPI') {
                        let arrStr = [];
                        rule?.value?.forEach((val: any, i) => {
                            let id: number = 0;
                            if (rule?.valueRefId[i]) {
                                id = parseInt(rule.valueRefId[i] ?? "") ?? 0;
                            }
                            arrStr.push({ id: id, name: val });
                        });
                        value = arrStr;
                    }
                    else if (rule.filter.valueDataType == 'User') {
                        let arrStr = [];
                        rule?.value?.forEach((val: any, i) => {
                            let id: number = 0;
                            if (rule?.valueRefId[i]) {
                                id = parseInt(rule.valueRefId[i] ?? "") ?? 0;
                            }
                            let userObj = users.find(x => x.id == id);
                            if (userObj) {
                                arrStr.push(userObj);
                            }
                        });
                        value = arrStr;
                    }
                    else if (rule.filter.valueDataType == 'Country') {
                        let id: number = 0;
                        if (rule?.valueRefId[0]) {
                            id = parseInt(rule.valueRefId[0] ?? "") ?? 0;
                        }
                        value = { id: id, name: rule.value[0] };
                    }
                    else if (rule.filter.valueDataType == 'DropdownList') {
                        let id: number = 0;
                        if (rule?.valueRefId[0]) {
                            id = parseInt(rule.valueRefId[0] ?? "") ?? 0;
                        }
                        value = { id: id, name: rule.value[0] };
                    }
                    else if (rule.filter.valueDataType == 'TreeSelect' && rule.filter.field.toLowerCase() == 'territoryname') {
                        if (rule?.value[0]) {
                            let territoryName: SavedSearchNS.TerritoryNameObject = JSON.parse(rule?.value[0]);
                            if (territoryName?.name) {
                                let obj: SavedSearchNS.TreeSelectObject = {
                                    id: territoryName.territoryId,
                                    name: territoryName.name,
                                    label: territoryName.name,
                                    data: territoryName.name,
                                    hasTerritory: true,
                                    children: [],
                                    parent: {
                                        id: territoryName.countryId,
                                        name: territoryName.country,
                                        label: territoryName.country,
                                        data: territoryName.country,
                                        hasTerritory: false,
                                        children: [],
                                        parent: null
                                    }
                                }
                                value = obj;
                            }
                            else {
                                let obj: SavedSearchNS.TreeSelectObject = {
                                    id: territoryName.countryId,
                                    name: territoryName.country,
                                    label: territoryName.country,
                                    data: territoryName.country,
                                    hasTerritory: false,
                                    children: [],
                                    parent: null
                                }
                                value = obj;
                            }

                        }
                        else {
                            value = null;
                        }
                    } else if (rule.filter.valueDataType == 'TreeSelect' && rule.filter.field.toLowerCase() != 'territoryname') {
                        let arrStr = [];
                        rule?.value?.forEach((val: any, i) => {
                            let id: number = 0;
                            if (rule?.valueRefId[i]) {
                                id = parseInt(rule.valueRefId[i] ?? "") ?? 0;
                            }
                            arrStr.push({ id: id, name: val });
                        });
                        value = arrStr;
                    }
                    else {
                        value = rule.value[0];
                    }
                }

            }
        }
    }
    return { value: value, value2: value2 };
}

export function restoreSavedSearchCombineRulesValue(ruleCombination: string, ruleData: any[]){
    const combinedRulesValueWithIds = extractSavedSearchRuleCombinationIds(ruleCombination);
    let combinedRulesValue = ruleCombination;

    combinedRulesValueWithIds.map(ruleNo=>{
        const ruleIndex = ruleData.findIndex(rule=> rule.ruleNo==ruleNo);
        combinedRulesValue = combinedRulesValue.replace(ruleNo, (ruleIndex+1).toString());
    });

    return combinedRulesValue;
}

export function extractSavedSearchRuleCombinationIds(input: string): string[] {
    const ids: string[] = [];
    const idRegex = /#\d+#/g;
    let match;

    while ((match = idRegex.exec(input)) !== null) {
        ids.push(match[0]);
    }

    return ids;
}
